import NumeroObjetSummary from '@/generated/controls/numeroObjet/NumeroObjetSummary.vue';
import NumeroObjet from '@/generated/classes/NumeroObjet';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: NumeroObjetSummary,
    methods: {
        getDisplay(numeroObjet: NumeroObjet): string {
            return numeroObjet.label + ' (' + numeroObjet.code + ')';
        }
    }
})
